import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Fundo, Grupo, Usuario } from './criar-grupos-de-investimento.model';
const BASE_PATH = environment.basePath;

@Injectable({
  providedIn: 'root'
})
export class CriarGruposDeInvestimentoService {

  constructor(
    private _$http: HttpClient
  ) { }

  getUsuarios() {
    return this
      ._$http
      .get<Usuario[]>(`${BASE_PATH}/bff/master/investmentGroup/edit/users`)
      .toPromise()
  }

  getFundos() {
    return this
      ._$http
      .get<Fundo[]>(`${BASE_PATH}/bff/master/investmentFund/aldrin/findById`)
      .toPromise()
  }

  postInvestmentGroup(grupo: Grupo) {
    return this
      ._$http
      .post(`${BASE_PATH}/bff/master/investmentGroup/create`, grupo)
      .toPromise()
  }


}
